<template>
<div>
    <Breadcrumbs main="CRM" title="Companies" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Company</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <b-row class="d-flex justify-content-center align-items-center">
                                    <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                        <b-input-group style="width: 340px;">
                                            <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>

                                        <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectConnected || selectedLabel">
                                            <feather type="x"></feather>
                                            <h7>Clear All</h7>
                                        </div>
                                    </b-col>

                                    <b-col xl="6">
                                        <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                            <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-8">
                                <div class="client-container" style="margin-top: 22px;">
                                    <div class="table-width">
                                        <div v-if="!loading && !error">
                                            <div class="table-responsive datatable-vue">
                                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered" style="overflow-x: scroll;">
                                                    <template #cell(index)="data">
                                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                                    </template>

                                                    <template #cell(name)="data">
                                                        <div  style="display: flex; flex-direction: column;">
                                                            <h7><span style="font-weight: 500;">{{ data.item.name }}</span> <span v-if="data.item.abbreviation">{{ data.item.abbreviation }}</span></h7>
                                                            <a :href="`mailto:${data.item.email}`">
                                                                <small> {{ data.item.email }}</small>
                                                            </a>
                                                            <small v-if="data.item.industry" class="badge badge-primary" style="max-width: fit-content;">{{ data.item.industry }}</small>
                                                        </div>
                                                    </template>

                                                    <template #cell(bin_tin)="data">
                                                        <div v-if="data.item.bin || data.item.tin" style="display: flex; flex-direction: column;">
                                                            <small v-if="data.item.tin"><span style="font-weight: 500;">TIN: </span>{{ data.item.tin }}</small>
                                                            <small v-if="data.item.bin"><span style="font-weight: 500;">BIN: </span>{{ data.item.bin }}</small>
                                                        </div>
                                                    </template>

                                                    <template #cell(address)="data">
                                                        <div v-if="data.item.address">
                                                            <small>{{ data.item.address }}</small>
                                                        </div>
                                                        <div v-if="data.item.website">
                                                            <small>{{ data.item.website }}</small>
                                                        </div>
                                                    </template>

                                                    
                                                    <template #cell(health)="data">
                                                         <span v-if="data.item.health"
                                                                class="badge"
                                                                :class="getHealthBadgeClass(data.item.health)"
                                                            >
                                                                {{ getHealthText(data.item.health) }}
                                                            </span>
                                                            <span v-else>
                                                                <small>N/A</small>
                                                            </span>
                                                    </template>

                                                    <template #cell(action)="data">
                                                        <span style="display: flex; gap: 12px;">
                                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletecompany(data.item.id)" title="Delete"></feather>
                                                            <feather @click="editItem(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                        </span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="loader-box">
                                                <div class="loader-10"></div>
                                            </div>
                                        </div>

                                        <b-col class="my-1 p-0">
                                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                                        </b-col>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-4">

                                <div class="d-flex flex-wrap" style="gap: 12px;">
                                    <div class="mini-box">
                                        <p class="mini-label">Total Companies</p>
                                        <h7 class="mini-value">{{ stats.total_companies }}</h7>
                                    </div>
                                    <div class="mini-box">
                                        <p class="mini-label">Healthy Accounts</p>
                                        <h7 class="mini-value">{{ stats.healthy_accounts }}</h7>
                                    </div>
                                     <div class="mini-box">
                                        <p class="mini-label">At Risk</p>
                                        <h7 class="mini-value">{{ stats.at_risk }}</h7>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Container-fluid Ends-->

    <!-- Company Create -->
    <b-modal id="modal-prevent-closing" size="lg" ref="modal" title="Create Company" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Company Name" label-for="name-input" invalid-feedback="Company name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Company Abbreviation" label-for="name-input" invalid-feedback="Company abbreviation is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.abbreviation" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Industry" label-for="name-input" invalid-feedback="Industry name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.industry" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company Health" label-for="health-name" invalid-feedback="Company health is required" :state="nameState">
                        <b-form-select id="health-name" v-model="company.health" :options="statusOptions" :state="nameState" required>
                                <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company Health Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="name-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Website" label-for="name-input" invalid-feedback="Website is required">
                        <b-form-input id="name-input" v-model="company.website"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="Company Owner" label-for="owner-name" invalid-feedback="Company owner is required" :state="nameState">
                <b-form-select id="owner-name" v-model="company.owner" :options="ownerOptions" :state="nameState" required>
                        <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Owner
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>



            <b-form-group label="Address" label-for="name-input" invalid-feedback="Company address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.address" :state="nameState" required></b-form-input>
            </b-form-group>
         

            <b-form-group label="BIN" label-for="name-input" invalid-feedback="BIN is required">
                <b-form-input id="name-input" v-model="company.bin"></b-form-input>
            </b-form-group>

            <b-form-group label="TIN" label-for="name-input" invalid-feedback="TIN is required">
                <b-form-input id="name-input" v-model="company.tin"></b-form-input>
            </b-form-group>
            
        </form>
    </b-modal>

    <!-- Edit Company -->
    <b-modal id="modal-prevent-closing-edit"  size="lg" ref="modal" title="Edit Company" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Company Name" label-for="name-input" invalid-feedback="Company name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="edit_company.name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Company Abbreviation" label-for="name-input" invalid-feedback="Company abbreviation is required" :state="nameState">
                        <b-form-input id="name-input" v-model="edit_company.abbreviation" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Industry" label-for="name-input" invalid-feedback="Industry name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="edit_company.industry" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company Health" label-for="health-name" invalid-feedback="Company health is required" :state="nameState">
                        <b-form-select id="health-name" v-model="edit_company.health" :options="statusOptions" :state="nameState" required>
                                <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company Health Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="name-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="name-input" v-model="edit_company.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Website" label-for="name-input" invalid-feedback="Website is required">
                        <b-form-input id="name-input" v-model="edit_company.website"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="Company Owner" label-for="owner-name" invalid-feedback="Company owner is required" :state="nameState">
                <b-form-select id="owner-name" v-model="edit_company.owner" :options="ownerOptions" :state="nameState" required>
                        <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Owner
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>



            <b-form-group label="Address" label-for="name-input" invalid-feedback="Company address is required" :state="nameState">
                <b-form-input id="name-input" v-model="edit_company.address" :state="nameState" required></b-form-input>
            </b-form-group>
         

            <b-form-group label="BIN" label-for="name-input" invalid-feedback="BIN is required">
                <b-form-input id="name-input" v-model="edit_company.bin"></b-form-input>
            </b-form-group>

            <b-form-group label="TIN" label-for="name-input" invalid-feedback="TIN is required">
                <b-form-input id="name-input" v-model="edit_company.tin"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this company?</div>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name'
                },
                {
                    key: 'bin_tin',
                    label: 'BIN & TIN'
                },
                {
                    key: 'address',
                    label: 'Address'
                },
                {
                    key: 'health',
                    label: 'Health'
                },

                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                },

            ],

            company: {
                name: '',
                industry:'',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: '',
                abbreviation: '',
                health:'',
                owner:''

            },
            nameState: null,
            edit_company: {
                id: '',
                name: '',
                industry:'',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: '',
                abbreviation: '',
                health:'',
                owner:''
            },

            statusOptions: [{
                    id: 1,
                    value: 'excellent',
                    text: 'Excellent'
                },
                {
                    id: 2,
                    value: 'healthy',
                    text: 'Healthy'
                },
                {
                    id: 3,
                    value: 'watch',
                    text: 'Watch',
                },
                {
                    id: 4,
                    value: 'at_risk',
                    text: 'At Risk',
                }
            ],

            delete_value: null,

            filter: null,

            filterShow: false,
            selectConnected: '',
            selectedLabel: null,

            initialLoad: true,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

        };
    },

    computed: {
        ...mapState({
            items: state => state.client.company_paginated,
            loading: state => state.client.submitLoading,
            error: state => state.client.submitError,
            count: state => state.client.company_count,

            salesReps: state => state.salesRep.salesRep,
            stats: state => state.client.company_stats


        }),
        
        ownerOptions(){
            return this.salesReps.map(rep => ({
                value: rep.id,
                text: rep?.user?.full_name || 'No Name'
            }));
        }

    },

    mounted() {
        this.$store.dispatch("salesRep/fetchSalesRep")
        this.$store.dispatch("client/fetchCompanyStats")
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }
    },

    watch: {
        assignedLabels: {
            handler: function (newVal, oldVal) {
                this.storeAssignedLabels(newVal);
            },
            deep: true
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("client/fetchCompanyPaginated", {
                    perPage: this.perPage,
                    currentPage: 1,
                    search_term: this.filter,

                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/crm/companies/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("client/fetchCompanyPaginated", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/crm/companies/list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("client/fetchCompanyPaginated", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    methods: {
        getHealthBadgeClass(status) {
            switch (status) {
                case 'excellent':
                    return 'bg-success';
                case 'healthy':
                    return 'bg-primary';
                case 'watch':
                    return 'bg-warning text-dark';
                case 'at_risk':
                    return 'bg-danger';
                default:
                    return 'bg-secondary';
            }
        },

        getHealthText(status) {
            const option = this.statusOptions.find(
                item => item.value === status
            );
            return option ? option.text : status;
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        fetchInitial() {
            this.$store.dispatch("client/fetchCompanyPaginated", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,

            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        clearFilter() {
            this.filterShow = false,
                this.filter = null

        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {

            this.company.name = null
            this.company.industry = null
            this.company.email = null
            this.company.website = null
            this.company.address = null
            this.company.bin = null
            this.company.tin = null
            this.company.abbreviation = null
            this.company.health = null
            this.company.owner = null


        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("client/addCompany", {
                company: this.company,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })

        },

        editItem(item) {
            console.log(item)
            this.edit_company.id = item ?.id
            this.edit_company.name = item ?.name
            this.edit_company.industry = item ?.industry
            this.edit_company.health = item ?.health
            this.edit_company.owner = item ?.owner?.id
            this.edit_company.website = item ?.website
            this.edit_company.email = item ?.email
            this.edit_company.address = item ?.address
            this.edit_company.bin = item ?.bin
            this.edit_company.tin = item ?.tin
            this.edit_company.abbreviation = item ?.abbreviation
        },

        resetEditModal() {
            this.edit_company.id = null
            this.edit_company.name = null
            this.edit_company.industry = null
            this.edit_company.email = null
            this.edit_company.website = null
            this.edit_company.address = null
            this.edit_company.bin = null
            this.edit_company.tin = null
            this.edit_company.abbreviation = null
            this.edit_company.health = null
            this.edit_company.owner = null
        },

        handleEditSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("client/updateCompany", {
                id: this.edit_company.id,
                company: this.edit_company,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })

        },

        deletecompany(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("client/deleteCompany", {
                item: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteLabel(id) {
            this.$store.dispatch("client/deleteLabel", id).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.mini-box {
    flex: 0 0 200px;
    width: 200px;
    padding: 16px 24px;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

}

.mini-box:hover {
    transform: translateY(-3px);
}

.mini-label {
    font-size: 14px;
    font-weight: 600;
    color: #62748e;
}
.mini-value{
    font-size: 18px;
    font-weight: 700;

}
</style>
